



















import {
    useI18n,
    useVueRouter,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import { capitalize } from '@superbet-group/web.lib.utilities';
import { isSocialEnabledOrAppEnabled } from '@socialFederation/helpers';
import {
    SdsTabItem,
    SdsTabList,
    SdsTabs,
} from '@superbet-group/web.lib.ui-components';
import {
    SocialRoutes,
    SportRoutes,
} from '@superbet-group/web.types';
import { TabItem } from '@shared/components/tabs/types';

export default defineComponent({
    name: 'SocialMobileSubnav',
    setup() {
        const { translate } = useI18n();
        const { route, router } = useVueRouter();

        const socialMobileSubnavTabs = computed(() => {
            const tabs: TabItem[] = [
                {
                    label: capitalize(translate('offer')),
                    value: SportRoutes.Landing,
                    className: 'e2e-subnav-tab-offer',
                },
            ];

            if (isSocialEnabledOrAppEnabled()) {
                tabs.push({
                    label: translate('supersocial'),
                    value: SocialRoutes.TicketFeed,
                    className: 'e2e-subnav-tab-social',
                });
            }

            return tabs;
        });

        const showSocialMobileSubnavTabs = computed(() => {
            // Show subnav only on defined tab routes
            return socialMobileSubnavTabs.value.some(({ value }) => value === route.value.name);
        });

        function onActiveTabSet(value: TabItem['value']) {
            // Makes sure we don't navigate to the same route
            if (value !== route.value.name) {
                router.value.replace({ name: value });
            }
        }

        return {
            socialMobileSubnavTabs,
            showSocialMobileSubnavTabs,
            onActiveTabSet,
        };
    },
    components: { SdsTabs, SdsTabList, SdsTabItem },
});
